import { defineAsyncComponent } from 'vue'
export default {
  creditor: defineAsyncComponent(() => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/layouts/creditor.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src3719381958/src/melembre-landing-page-v2/layouts/default.vue").then(m => m.default || m))
}